import axios, { AxiosResponse } from "axios";
import { ArrayFromEnvelope, configService, ObjectFromEnvelope } from "./config.service";
import { Position } from "../models/positions";
import { PositionCategory } from "../models/positionCategories";

class PositionService {
  async fetchPositions(): Promise<Position[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<Position[]>(
          configService.APIInstitutionUrl(
            "positions.json?institution_id=" + configService.institutionId()
          )
        )
        .then((response: AxiosResponse) => {
          resolve(Position.fromJSONArray(ArrayFromEnvelope<Position>(response.data)));
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  async fetchPositionCategories(): Promise<PositionCategory[]> {
    return new Promise((resolve, reject) => {
      axios
        .get<PositionCategory[]>(
          configService.APIInstitutionUrl(
            "position_categories.json?institution_id=" + configService.institutionId()
          )
        )
        .then((response: AxiosResponse) => {
          resolve(
            PositionCategory.fromJSONArray(ArrayFromEnvelope<PositionCategory>(response.data))
          );
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async createPosition(position: Position): Promise<Position> {
    return new Promise((resolve, reject) => {
      axios
        .post<Position>(
          configService.APIInstitutionUrl("positions.json"),
          position.convertToPostObject()
        )
        .then((response: AxiosResponse) => {
          resolve(Position.fromJSON(ObjectFromEnvelope<Position>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }
  async updatePosition(position: Position): Promise<Position> {
    return new Promise((resolve, reject) => {
      axios
        .put<Position>(
          configService.APIInstitutionUrl("positions/" + position.id + ".json"),
          position.convertToPutObject()
        )
        .then((response: AxiosResponse) => {
          resolve(Position.fromJSON(ObjectFromEnvelope<Position>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }
  async deletePosition(positionId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete<Position>(configService.APIInstitutionUrl("positions/" + positionId + ".json"))
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  }
  async createPositionCategory(positioncategory: PositionCategory): Promise<PositionCategory> {
    return new Promise((resolve, reject) => {
      axios
        .post<PositionCategory>(
          configService.APIInstitutionUrl("position_categories.json"),
          positioncategory.convertToPostObject()
        )
        .then((response: AxiosResponse) => {
          resolve(PositionCategory.fromJSON(ObjectFromEnvelope<PositionCategory>(response.data)));
        })
        .catch((error) => reject(error));
    });
  }
  async deletePositionCategory(positioncategoryId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      axios
        .delete<PositionCategory>(
          configService.APIInstitutionUrl("position_categories/" + positioncategoryId + ".json")
        )
        .then((response: AxiosResponse) => {
          resolve(response.data);
        })
        .catch((error) => reject(error));
    });
  }
}

export const positionService: PositionService = new PositionService();
